import { useContext } from "react";
import { FaSun, FaMoon } from "react-icons/fa";
import { MainContext } from "../AppContext";

interface DarkModeToggleProps {
  className?: string;
}

const DarkModeToggle: React.FC<DarkModeToggleProps> = ({ className }) => {
  const { isDarkMode, setIsDarkMode } = useContext(MainContext);

  const toggleDarkMode = () => {
    if (isDarkMode) {
      document.documentElement.classList.remove("dark");
      localStorage.setItem("theme", "light");
    } else {
      document.documentElement.classList.add("dark");
      localStorage.setItem("theme", "dark");
    }
    setIsDarkMode(!isDarkMode);
  };

  return (
    <button
      onClick={toggleDarkMode}
      className={`
        flex items-center justify-center w-9 h-9 rounded-md
        bg-background border border-input
        text-foreground
        hover:bg-accent hover:text-accent-foreground
        transition-colors
        ${className}
      `}
      aria-label={isDarkMode ? "Switch to light mode" : "Switch to dark mode"}
    >
      {isDarkMode ? (
        <FaSun className="w-3.5 h-3.5" />
      ) : (
        <FaMoon className="w-3.5 h-3.5" />
      )}
    </button>
  );
};

export default DarkModeToggle;
